export default __webpack_public_path__ + "static/media/STLCoverLetterTranscript.059992be.pdf";